'use client'

import {usePathname} from 'next/navigation'
import {getPublicLoadingPadding, PublicPageContentSkeleton} from './PublicEntryLoading'
import {resolvePublicSitePage} from './publicSiteNavigation'
import {publicEntryStyles} from './publicEntryStyles'

export function PublicEntryRouteLoading() {
    const page = resolvePublicSitePage(usePathname())
    return (
        <div className={`${publicEntryStyles.content} ${getPublicLoadingPadding(page)}`}>
            <PublicPageContentSkeleton page={page}/>
        </div>
    )
}
